function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
import * as React from 'react';
import PartnerLogo from "./PartnerLogo";
import CardV2 from "../basic/Card/Card";
import Box from "../basic/Box";
import { breakPoint, color, gradient, css, transition, placeholder, StyleSheet } from "../../styles/theme";
import CardSection, { CARD_SECTION_TYPE } from "../basic/Card/CardSection";
import CardText, { CARD_TEXT_TYPE } from "../basic/Card/CardText";
import TagBadge from "../basic/TagBadge";
export var PRODUCT_CARD_TYPE = {
  COURSE: 'course',
  DEGREE: 'degree',
  S12N: 's12n'
};
export var PRODUCT_CARD_SIZE = {
  LG: 'lg',
  MD: 'md',
  SM: 'sm',
  XS: 'xs'
};
var LINE_HEIGHT = 24;
var LG_CONFIG = {
  titleSectionTopMargin: {
    withGradient: 12,
    withoutGradient: 48
  },
  titleFontSize: 24,
  partnerLogoTopSpacing: 96,
  partnerLogoLeftSpacing: 24,
  partnerLogoDimension: 72,
  partnerLogoPadding: 8,
  tagTopSpacing: 120,
  cardActionsBottomSpacing: 4,
  cardHeight: 384,
  minWidth: 240,
  imageHeight: {
    withGradient: 168,
    withoutGradient: 132
  },
  gradientTop: 132,
  gradientDeg: -10,
  ribbonDeg: -250,
  titleMaxLines: 3,
  subtitleMaxLines: 3,
  titleStyle: {
    marginBottom: 6
  }
};
var MD_CONFIG = {
  titleSectionTopMargin: {
    withGradient: 12,
    withoutGradient: 28
  },
  titleFontSize: 24,
  partnerLogoTopSpacing: 48,
  partnerLogoLeftSpacing: 24,
  partnerLogoDimension: 72,
  partnerLogoPadding: 8,
  tagTopSpacing: 72,
  cardActionsBottomSpacing: 4,
  cardHeight: 336,
  minWidth: 240,
  imageHeight: {
    withGradient: 120,
    withoutGradient: 108
  },
  gradientTop: 84,
  gradientDeg: -10,
  ribbonDeg: -250,
  titleMaxLines: 2,
  subtitleMaxLines: 2,
  titleStyle: {
    marginBottom: 6
  }
};
var SM_CONFIG = {
  titleSectionTopMargin: {
    withGradient: 2,
    withoutGradient: 6
  },
  titleFontSize: 18,
  partnerLogoTopSpacing: 28,
  partnerLogoLeftSpacing: 24,
  partnerLogoDimension: 60,
  partnerLogoPadding: 4,
  tagTopSpacing: 46,
  cardActionsBottomSpacing: 4,
  cardHeight: 252,
  minWidth: 216,
  imageHeight: {
    withGradient: 80,
    withoutGradient: 72
  },
  gradientTop: 60,
  gradientDeg: -6,
  ribbonDeg: -250,
  titleMaxLines: 3,
  subtitleMaxLines: 2,
  titleStyle: {
    marginBottom: 6,
    fontSize: 18
  },
  subtitleStyle: {
    fontSize: 12,
    lineHeight: '18px' // somehow this cannot be just a numeric value
  }
};
var XS_CONFIG = {
  titleSectionTopMargin: {
    withGradient: 2,
    withoutGradient: 6
  },
  titleFontSize: 18,
  partnerLogoTopSpacing: 18,
  partnerLogoLeftSpacing: 24,
  partnerLogoDimension: 60,
  partnerLogoPadding: 4,
  tagTopSpacing: 24,
  cardActionsBottomSpacing: 4,
  cardHeight: 186,
  minWidth: 216,
  imageHeight: {
    withGradient: 72,
    withoutGradient: 66
  },
  gradientTop: 60,
  gradientDeg: 0,
  // the card is too short to have a meaningful slanted shape
  ribbonDeg: -250,
  titleMaxLines: 2,
  subtitleMaxLines: 2,
  titleStyle: {
    marginBottom: 6,
    fontSize: 16,
    lineHeight: '22px',
    fontFamily: "'OpenSans-Semibold', Arial, sans-serif"
  },
  subtitleStyle: {
    fontSize: 12,
    lineHeight: '18px' // somehow this cannot be just a numeric value
  }
};
var cardConfigMap = {
  xs: XS_CONFIG,
  sm: SM_CONFIG,
  md: MD_CONFIG,
  lg: LG_CONFIG
};
var placeholderStyles = StyleSheet.create({
  cardImage: {
    width: '100%',
    height: '100%',
    backgroundColor: color.darkGray
  },
  titlePlaceholder: {
    maxWidth: 250,
    height: LINE_HEIGHT,
    backgroundColor: color.gray,
    animationDelay: "".concat(placeholder.animationDuration / 4, "s")
  },
  subtitlePlaceholder: {
    maxWidth: 150,
    height: LINE_HEIGHT,
    backgroundColor: color.gray,
    animationDelay: "".concat(placeholder.animationDuration / 4, "s")
  },
  numberOfCoursesPlaceholder: {
    width: 100,
    height: LINE_HEIGHT,
    backgroundColor: color.gray,
    animationDelay: "".concat(placeholder.animationDuration / 4, "s")
  }
});
function getCardStyles(imageSrc, isThemeDark, showGradient, configData, dir) {
  var isRightToLeft = dir === 'rtl';
  return StyleSheet.create({
    ProductCard: _defineProperty({
      height: configData.cardHeight,
      backgroundColor: isThemeDark ? color.primary : color.white,
      transition: transition.easeOut(),
      textAlign: isRightToLeft ? 'right' : 'left'
    }, "@media (max-width: ".concat(breakPoint.xs, "px)"), {
      minWidth: configData.minWidth
    }),
    badgeWrapper: {
      margin: '12px 12px 0 0'
    },
    cardActions: {
      width: '100%',
      position: 'absolute',
      bottom: configData.cardActionsBottomSpacing
    },
    cardImageContainer: {
      height: showGradient ? configData.imageHeight.withGradient : configData.imageHeight.withoutGradient
    },
    cardImage: {
      width: '100%',
      height: '100%',
      backgroundImage: imageSrc ? "url(".concat(imageSrc, ")") : '',
      backgroundColor: color.lightPrimary,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    },
    titleSection: {
      position: 'relative',
      marginTop: showGradient ? configData.titleSectionTopMargin.withGradient : configData.titleSectionTopMargin.withoutGradient,
      zIndex: 1
    },
    tagTopHalf: {
      position: 'absolute',
      top: configData.tagTopSpacing,
      left: isRightToLeft ? 0 : undefined,
      right: isRightToLeft ? undefined : 0,
      height: 24,
      width: '36%',
      transform: 'skewX(45deg)',
      backgroundColor: color.dividerLight
    },
    tagBottomHalf: {
      position: 'absolute',
      top: configData.tagTopSpacing,
      left: isRightToLeft ? 0 : undefined,
      right: isRightToLeft ? undefined : 0,
      height: 24,
      width: '36%',
      opacity: 0.6,
      transform: 'skewX(-45deg)',
      backgroundColor: color.primaryTextThemeDark
    },
    tag: {
      'position': 'absolute',
      'top': configData.tagTopSpacing,
      'left': isRightToLeft ? 0 : undefined,
      'right': isRightToLeft ? undefined : 0,
      'height': 18,
      'padding': '0px 12px',
      'textAlign': 'right',
      'color': color.darkPrimary,
      'fontSize': 12,
      'fontWeight': 'bold',
      'textTransform': 'uppercase',
      'backgroundColor': color.dividerLight,
      ':before': {
        content: "''",
        display: 'block',
        position: 'absolute',
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: isRightToLeft ? '0 0 9px 9px' : '0 9px 9px 0',
        left: isRightToLeft ? undefined : -9,
        right: isRightToLeft ? -9 : undefined,
        borderColor: isRightToLeft ? "transparent transparent transparent ".concat(color.dividerLight) : "transparent ".concat(color.dividerLight, " transparent transparent")
      },
      ':after': {
        content: "''",
        display: 'block',
        position: 'absolute',
        opacity: 0.6,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderColor: "transparent transparent ".concat(color.primaryTextThemeDark, " transparent"),
        top: 9,
        left: isRightToLeft ? undefined : -9,
        right: isRightToLeft ? -9 : undefined,
        borderWidth: isRightToLeft ? '0 9px 9px 0' : '0 0 9px 9px'
      }
    }
  });
}
function getGradientStyle(gradient, configData) {
  return StyleSheet.create({
    gradient: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: configData.gradientTop,
      backgroundImage: "linear-gradient(".concat(gradient.deg, "deg, ").concat(gradient.start, ", ").concat(gradient.end, ")"),
      transform: "skewY(".concat(configData.gradientDeg, "deg)")
    }
  });
}
function getPartnerLogoStyle(configData, dir) {
  var isRightToLeft = dir === 'rtl';
  return {
    width: configData.partnerLogoDimension,
    height: configData.partnerLogoDimension,
    padding: configData.partnerLogoPadding,
    top: configData.partnerLogoTopSpacing,
    left: isRightToLeft ? undefined : configData.partnerLogoLeftSpacing,
    right: isRightToLeft ? configData.partnerLogoLeftSpacing : undefined
  };
}
export default function ProductCard(_ref) {
  var gradient = _ref.gradient,
    badge = _ref.badge,
    imageSrc = _ref.imageSrc,
    logoSrc = _ref.logoSrc,
    title = _ref.title,
    titleLang = _ref.titleLang,
    titleMaxLines = _ref.titleMaxLines,
    subtitle = _ref.subtitle,
    subtitleMaxLines = _ref.subtitleMaxLines,
    label = _ref.label,
    tag = _ref.tag,
    actionsElement = _ref.actionsElement,
    htmlAttributes = _ref.htmlAttributes,
    isInteractive = _ref.isInteractive,
    isThemeDark = _ref.isThemeDark,
    onClick = _ref.onClick,
    showGradient = _ref.showGradient,
    style = _ref.style,
    type = _ref.type,
    size = _ref.size,
    tagClassNames = _ref.tagClassNames,
    children = _ref.children,
    useDivForTitleElement = _ref.useDivForTitleElement,
    dir = _ref.dir;
  var shouldShowGradient = showGradient === undefined ? type === PRODUCT_CARD_TYPE.S12N : showGradient;
  var configData = cardConfigMap[size];
  var cardStyles = getCardStyles(imageSrc, isThemeDark, shouldShowGradient, configData, dir);
  var gradientStyle = getGradientStyle(gradient, configData);
  var partnerLogoStyle = getPartnerLogoStyle(configData, dir);
  var onClickHandler = function onClickHandler(event) {
    event.preventDefault();
    if (onClick) {
      onClick();
    }
  };
  var onClickProp = onClick ? {
    onClick: onClickHandler
  } : {};
  var titleHtmlAttr = titleLang ? {
    lang: titleLang
  } : undefined;
  var isRightToLeft = dir === 'rtl';
  return /*#__PURE__*/React.createElement(CardV2, {
    rootClassName: cardStyles.ProductCard,
    style: style,
    isInteractive: onClick || isInteractive,
    isThemeDark: isThemeDark || shouldShowGradient,
    htmlAttributes: _objectSpread(_objectSpread({}, onClickProp), htmlAttributes)
  }, /*#__PURE__*/React.createElement(CardSection, {
    rootClassName: cardStyles.cardImageContainer,
    type: CARD_SECTION_TYPE.IMAGE
  }, /*#__PURE__*/React.createElement("span", _extends({}, css(cardStyles.cardImage), {
    "aria-hidden": true
  }))), shouldShowGradient && /*#__PURE__*/React.createElement("div", css(gradientStyle.gradient)), logoSrc && /*#__PURE__*/React.createElement(PartnerLogo, {
    logoSrc: logoSrc,
    showGradient: shouldShowGradient,
    style: partnerLogoStyle
  }), tag && /*#__PURE__*/React.createElement("div", css(tagClassNames, cardStyles.tag), tag), /*#__PURE__*/React.createElement("div", css(cardStyles.badgeWrapper), /*#__PURE__*/React.createElement(TagBadge, {
    text: badge
  })), /*#__PURE__*/React.createElement(CardSection, {
    rootClassName: cardStyles.titleSection
  }, /*#__PURE__*/React.createElement(CardText, {
    style: configData.titleStyle,
    type: CARD_TEXT_TYPE.TITLE,
    text: title,
    maxLines: titleMaxLines || configData.titleMaxLines,
    htmlAttributes: titleHtmlAttr,
    shouldTruncate: true,
    shouldRenderDiv: useDivForTitleElement
  }), /*#__PURE__*/React.createElement(CardText, {
    style: configData.subtitleStyle || {},
    type: CARD_TEXT_TYPE.SUBTITLE,
    text: subtitle,
    maxLines: subtitleMaxLines || configData.subtitleMaxLines,
    shouldTruncate: true
  })), children, (label || actionsElement) && /*#__PURE__*/React.createElement(CardSection, {
    rootClassName: cardStyles.cardActions
  }, /*#__PURE__*/React.createElement(Box, {
    alignItems: "center",
    justifyContent: "between",
    flexDirection: isRightToLeft ? 'row-reverse' : 'row'
  }, /*#__PURE__*/React.createElement(CardText, {
    type: CARD_TEXT_TYPE.LABEL,
    text: label
  }), actionsElement)));
}
export var ProductCardPlaceholder = function ProductCardPlaceholder(_ref2) {
  var hidePartnerLogo = _ref2.hidePartnerLogo,
    hideLabel = _ref2.hideLabel,
    size = _ref2.size,
    dir = _ref2.dir;
  var configData = cardConfigMap[size || 'lg'];
  var cardStyles = getCardStyles('', false, false, configData, dir);
  var partnerLogoStyle = getPartnerLogoStyle(configData, dir);
  return /*#__PURE__*/React.createElement(CardV2, {
    rootClassName: cardStyles.ProductCard
  }, /*#__PURE__*/React.createElement(CardSection, {
    rootClassName: cardStyles.cardImageContainer,
    type: CARD_SECTION_TYPE.IMAGE
  }, /*#__PURE__*/React.createElement("span", css(placeholder.styles.shimmer, placeholderStyles.cardImage))), !hidePartnerLogo && /*#__PURE__*/React.createElement(PartnerLogo, {
    style: partnerLogoStyle
  }), /*#__PURE__*/React.createElement(CardSection, {
    rootClassName: cardStyles.titleSection
  }, /*#__PURE__*/React.createElement("div", _extends({}, css(placeholder.styles.shimmer, placeholderStyles.titlePlaceholder), {
    style: configData.titleStyle
  })), /*#__PURE__*/React.createElement("div", css(placeholder.styles.shimmer, placeholderStyles.subtitlePlaceholder))), !hideLabel && /*#__PURE__*/React.createElement(CardSection, {
    rootClassName: cardStyles.cardActions
  }, /*#__PURE__*/React.createElement("div", css(placeholder.styles.shimmer, placeholderStyles.numberOfCoursesPlaceholder))));
};
ProductCard.defaultProps = {
  gradient: gradient.productCardSpecialization,
  type: PRODUCT_CARD_TYPE.COURSE,
  size: PRODUCT_CARD_SIZE.LG
};